/**
 * Leest een File object en geeft Base64-string terug (zonder data URL prefix).
 */
export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      // result = "data:application/pdf;base64,XXXX" — we keep the full data URL
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

/**
 * Opent een opgeslagen base64 PDF in een nieuw tabblad.
 */
export function openBase64Pdf(dataUrl, filename = 'document.pdf') {
  if (!dataUrl) return;
  // dataUrl is already a full data URL string
  const win = window.open();
  if (win) {
    win.document.write(
      `<html><head><title>${filename}</title></head>` +
      `<body style="margin:0"><embed width="100%" height="100%" src="${dataUrl}" type="application/pdf"/></body></html>`
    );
  }
}
